import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { SmallText, Title } from '../../../components/presentation/Text'
import { useNonCompliance } from './_load/NonComplianceLoader'
import { useNonComplianceActionsList } from '../../../utils/actions/nonCompliance/list'
import { useNonComplianceFastActionsList } from '../../../utils/actions/nonCompliance/fastList'
import DropdownLink from '../../../components/navigation/DropdownLink'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Icon from '../../../components/shapes/Icon'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Separator from '../../../components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation()

  const nonCompliance = useNonCompliance()
  const placeName = nonCompliance.place?.name
  const placeResume = nonCompliance.place?.resume
  const checklistName = nonCompliance.question?.checklist?.name
  const questionName = nonCompliance.question?.name

  const fastActions = useNonComplianceFastActionsList(nonCompliance)

  const [options] = useNonComplianceActionsList(nonCompliance, [], { hide: ['seeDetails'] })

  return (
    <FlexGrid justify="flex-start" gutter={0.3}>
      <FlexCol flex={4}>
        <SmallText color={COLORS.dark3} size="xxsmall">
          {placeResume}
        </SmallText>

        <Title size="h4" noMargin>
          {placeName}
        </Title>

        <SmallText color={COLORS.dark3}>
          {questionName} ({checklistName})
        </SmallText>
      </FlexCol>

      <FlexCol flex={1}></FlexCol>

      <FlexCol>
        <RefetchingIndicator />
      </FlexCol>

      {fastActions.map(action => (
        <>
          <FlexCol key={action.label}>
            <IconText iconLeft={action.icon} color="dark3" bold {...action} noWrap />
          </FlexCol>
          <Separator vertical />
        </>
      ))}

      <FlexCol>
        <DropdownLink
          fromRight
          options={options}
          actionContent={<Icon name="BsThreeDotsVertical" ize="1.4rem" />}
          t={t}
        />
      </FlexCol>
    </FlexGrid>
  )
}

export default ModalHeader
